import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { CreditCardType, TokenizedPaymentCard } from '@/models';

@Component({
  name: 'CmgPaymentCardLogo',
})
export default class CmgPaymentCardLogo extends Vue {
  @Prop({ required: true, type: Object })
  card!: TokenizedPaymentCard;

  @Prop({ type: Boolean })
  filled?: boolean;

  get creditCardLogoUrl(): string {
    const logos = this.$appStore.state.cms.images.logos;

    if (this.card.isGiftCard) {
      return logos.giftCardLogoFilled.default;
    }

    switch (this.card.paymentMethod) {
      case CreditCardType.Visa:
        return (this.filled ? logos.visaLogoFilled : logos.visaLogo).default;
      case CreditCardType.Mastercard:
        return (this.filled ? logos.mastercardLogoFilled : logos.mastercardLogo).default;
      case CreditCardType.Amex:
        return (this.filled ? logos.amexLogoFilled : logos.amexLogo).default;
      case CreditCardType.Discover:
        return (this.filled ? logos.discoverCardLogoFilled : logos.discoverCardLogo).default;
      default:
        return (this.filled ? logos.defaultCardLogoFilled : logos.defaultCardLogo).default;
    }
  }
}
